class LanderBuyBox extends HTMLElement {
  connectedCallback() {
    if (!this.__initialized) {
      this.__initialized = true;
      this.init();
    }
  }

  init() {
    // Initialize tab switching
    this.tabs = this.querySelectorAll('.lander-buybox--tab');
    this.subscribeContent = this.querySelector('.lander-buybox--subscribe-content');
    this.oneTimeContent = this.querySelector('.lander-buybox--one-time-content');
    
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.switchTab(index));
    });

    // Initialize accordions only once
    this.initializeAccordions();

    // Initialize forms
    this.forms = this.querySelectorAll('form');
    this.forms.forEach(form => {
      form.addEventListener('submit', this.handleSubmit.bind(this));
    });

    // Check if direct to checkout is enabled
    this.directToCheckout = this.hasAttribute('data-direct-to-checkout');

    // Initialize modal functionality
    this.initializeModal();
  }

  initializeAccordions() {
    // Initialize all accordion headers
    const headers = this.querySelectorAll('.lander-buybox--mobile-header');
    
    headers.forEach(header => {
      header.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleAccordion(header);
      });
    });

    // Set default open accordions for each tab
    const subscribeDefaultHeader = this.subscribeContent.querySelector('.lander-buybox--mobile-option.default-open .lander-buybox--mobile-header');
    const oneTimeDefaultHeader = this.oneTimeContent.querySelector('.lander-buybox--mobile-option.default-open .lander-buybox--mobile-header');
    
    // Open default for subscribe tab
    if (subscribeDefaultHeader) {
      this.setAccordionOpen(subscribeDefaultHeader);
    } else {
      const subscribeFirstHeader = this.subscribeContent.querySelector('.lander-buybox--mobile-header');
      if (subscribeFirstHeader) {
        this.setAccordionOpen(subscribeFirstHeader);
      }
    }
    
    // Open default for one-time tab
    if (oneTimeDefaultHeader) {
      this.setAccordionOpen(oneTimeDefaultHeader);
    } else {
      const oneTimeFirstHeader = this.oneTimeContent.querySelector('.lander-buybox--mobile-header');
      if (oneTimeFirstHeader) {
        this.setAccordionOpen(oneTimeFirstHeader);
      }
    }
  }

  setAccordionOpen(header) {
    const option = header.dataset.option;
    const accordion = header.closest('.lander-buybox--mobile-accordion');
    const content = accordion.querySelector(`.lander-buybox--mobile-content[data-option="${option}"]`);
    const arrow = header.querySelector('.lander-buybox--mobile-arrow');
    
    // Set accordion to open state
    if (content) content.classList.add('open');
    if (arrow) arrow.classList.add('open');
    header.classList.add('open');
  }

  toggleAccordion(header) {
    const option = header.dataset.option;
    const accordion = header.closest('.lander-buybox--mobile-accordion');
    const content = accordion.querySelector(`.lander-buybox--mobile-content[data-option="${option}"]`);
    const arrow = header.querySelector('.lander-buybox--mobile-arrow');
    
    const isCurrentlyOpen = header.classList.contains('open');
    
    if (isCurrentlyOpen) {
      return;
    }
    
    const currentTab = header.closest('.lander-buybox--subscribe-content, .lander-buybox--one-time-content');
    const otherHeaders = currentTab.querySelectorAll('.lander-buybox--mobile-header');
    
    otherHeaders.forEach(h => {
      if (h !== header) {
        const otherOption = h.dataset.option;
        const otherAccordion = h.closest('.lander-buybox--mobile-accordion');
        const otherContent = otherAccordion.querySelector(`.lander-buybox--mobile-content[data-option="${otherOption}"]`);
        const otherArrow = h.querySelector('.lander-buybox--mobile-arrow');
        if (otherContent) otherContent.classList.remove('open');
        if (otherArrow) otherArrow.classList.remove('open');
        h.classList.remove('open');
      }
    });
    
    if (content) {
      content.classList.add('open');
    }
    if (arrow) arrow.classList.add('open');
    header.classList.add('open');
  }

  switchTab(index) {
    this.tabs.forEach(tab => tab.classList.remove('active'));
    this.tabs[index].classList.add('active');
    
    if (index === 0) { // Subscribe & Save
      this.subscribeContent.style.display = 'block';
      this.oneTimeContent.style.display = 'none';
    } else { // One-Time Purchase
      this.subscribeContent.style.display = 'none';
      this.oneTimeContent.style.display = 'block';
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    const form = event.target;
    const button = form.querySelector('button[type="submit"]');
    
    if (button.disabled) return;
    
    this.setLoading(button, true);
    
    const formData = new FormData(form);
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json'
      },
      body: formData
    })
    .then(response => response.json())
    .then(() => {
      if (this.directToCheckout) {
        window.location.href = '/checkout';
      }
    })
    .catch(error => {
      console.error('Error:', error);
    })
    .finally(() => {
      this.setLoading(button, false);
    });
  }

  setLoading(button, isLoading) {
    button.disabled = isLoading;
    button.classList.toggle('is-loading', isLoading);
  }

  initializeModal() {
    this.viewMoreButton = this.querySelector('#viewMoreBenefits');
    this.modalOverlay = this.querySelector('#benefitsModalOverlay');
    this.closeModalButton = this.querySelector('#closeModal');
    this.closeModalXButton = this.querySelector('#closeModalX');

    if (this.viewMoreButton && this.modalOverlay && this.closeModalButton) {
      this.viewMoreButton.addEventListener('click', () => this.openModal());
      this.closeModalButton.addEventListener('click', () => this.closeModal());
      
      // Add event listener for X button if it exists
      if (this.closeModalXButton) {
        this.closeModalXButton.addEventListener('click', () => this.closeModal());
      }
      
      this.modalOverlay.addEventListener('click', (e) => {
        if (e.target === this.modalOverlay) {
          this.closeModal();
        }
      });

      // Close modal on ESC key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.modalOverlay.classList.contains('active')) {
          this.closeModal();
        }
      });
    }
  }

  openModal() {
    if (this.modalOverlay) {
      this.modalOverlay.classList.add('active');
      document.body.style.overflow = 'hidden'; // Prevent background scrolling
    }
  }

  closeModal() {
    if (this.modalOverlay) {
      this.modalOverlay.classList.remove('active');
      document.body.style.overflow = ''; // Restore background scrolling
    }
  }
}

if (!customElements.get('lander-buy-box')) {
  customElements.define('lander-buy-box', LanderBuyBox);
}

// Initialize any existing buy boxes when the DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const buyBoxes = document.querySelectorAll('lander-buy-box');
  buyBoxes.forEach(box => {
    if (!box.__initialized) {
      box.__initialized = true;
      box.init();
    }
  });
}); 